module.exports = __webpack_public_path__ + "static/seo-and-translation-services-471698093258c165972c09fee2c28d93.jpg";